import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

import { ButtonPresetTheme, ButtonVariant } from 'hds-react';
import React from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import Button from 'shared/components/button/Button';
import {
  $Grid,
  $GridCell,
} from 'shared/components/forms/section/FormSection.sc';
import { useTheme } from 'styled-components';

import { $ActionsWrapper, $ViewerWrapper } from './PdfViewer.sc';
import { usePdfViewer } from './usePdfViewer';

pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.mjs';

type PdfViewerProps = {
  file: string;
  scale?: number;
};

const PdfViewer: React.FC<PdfViewerProps> = ({ file, scale }) => {
  const {
    t,
    handleDocumentLoadSuccess,
    handleNext,
    handleBack,
    currentPage,
    pagesCount,
  } = usePdfViewer();

  const theme = useTheme();

  const pdfOptions = React.useMemo(() => ({ withCredentials: true }), []);

  return (
    <>
      <$ViewerWrapper>
        <Document
          onLoadSuccess={handleDocumentLoadSuccess}
          file={file}
          options={pdfOptions}
          className="Document"
        >
          <Page pageNumber={currentPage} scale={scale} />
        </Document>
      </$ViewerWrapper>
      {pagesCount > 1 ? (
        <$Grid
          css={`
            margin-top: ${theme.spacing.l};
            margin-bottom: ${theme.spacing.xl};
          `}
        >
          <$GridCell $colSpan={2}>
            <Button
              disabled={currentPage === 1}
              theme={ButtonPresetTheme.Black}
              variant={ButtonVariant.Secondary}
              onClick={handleBack}
            >
              {t('common:pdfViewer.previous')}
            </Button>
          </$GridCell>
          <$GridCell $colSpan={1}>
            <$ActionsWrapper>
              {`${t('common:pdfViewer.page')} ${currentPage} / ${pagesCount}`}
            </$ActionsWrapper>
          </$GridCell>
          <$GridCell $colSpan={2}>
            <Button
              disabled={currentPage === pagesCount}
              theme={ButtonPresetTheme.Black}
              variant={ButtonVariant.Secondary}
              onClick={handleNext}
            >
              {t('common:pdfViewer.next')}
            </Button>
          </$GridCell>
        </$Grid>
      ) : null}
    </>
  );
};

export default PdfViewer;
